import { AxiosResponse } from "axios";
import {
  IComplaint,
  IComplaintFilter,
  IComplaintTopic,
  IComplaintTopicWithPagination,
  IComplaintWithPagination,
  ICreateComplaint,
  ICreateComplaintTopic,
  IUpdateComplaintStatus,
  IUpdateComplaintTopic,
} from "../interface/appeal";
import { http } from "../utils/http";

// Admin Routes
export const createComplaintTopicApi = (
  data: ICreateComplaintTopic
): Promise<AxiosResponse<IComplaintTopic>> => {
  return http.post("/v1/admin/complaint-topics", data);
};

export const updateComplaintTopicApi = (
  id: string,
  data: IUpdateComplaintTopic
): Promise<AxiosResponse<IComplaintTopic>> => {
  return http.put(`/v1/admin/complaint-topics/${id}`, data);
};

export const deleteComplaintTopicApi = (
  id: string
): Promise<AxiosResponse<void>> => {
  return http.del(`/v1/admin/complaint-topics/${id}`);
};

export const getComplaintsApi = (
  filter: IComplaintFilter
): Promise<AxiosResponse<IComplaintWithPagination>> => {
  return http.get("/v1/admin/complaints", { params: filter });
};

export const updateComplaintStatusApi = (
  id: string,
  data: IUpdateComplaintStatus
): Promise<AxiosResponse<IComplaint>> => {
  return http.patch(`/v1/admin/complaints/${id}`, data);
};

// User Routes
export const createComplaintApi = (
  data: ICreateComplaint
): Promise<AxiosResponse<IComplaint>> => {
  return http.post("/v1/complaints", data);
};

export const getUserComplaintsApi = (
  filter: IComplaintFilter
): Promise<AxiosResponse<IComplaintWithPagination>> => {
  return http.get("/v1/complaints", { params: filter });
};

export const getComplaintByIdApi = (
  id: string
): Promise<AxiosResponse<IComplaint>> => {
  return http.get(`/v1/complaints/${id}`);
};

// Public Routes
export const getComplaintTopicsApi = (): Promise<
  AxiosResponse<IComplaintTopic[]>
> => {
  return http.get("/v1/complaint-topics");
};

export const getComplaintTopicByIdApi = (
  id: string
): Promise<AxiosResponse<IComplaintTopic>> => {
  return http.get(`/v1/complaint-topics/${id}`);
};
